
export const batchMinusYearsFromCurrentYear: number = 5;

